import { Amplify } from 'aws-amplify'
import { fetchAuthSession } from 'aws-amplify/auth'

const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID
const userPoolClientId = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID

export const isAuthConfigured = Boolean(userPoolId && userPoolClientId)

let hasConfiguredAuth = false

export function configureAuth() {
  if (!isAuthConfigured || hasConfiguredAuth) return isAuthConfigured

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId
      }
    }
  })
  hasConfiguredAuth = true
  return true
}

/** Returns an automatically refreshed Cognito ID token for API Gateway. */
export async function getApiToken(): Promise<string | undefined> {
  if (!isAuthConfigured) return undefined

  try {
    const session = await fetchAuthSession()
    return session.tokens?.idToken?.toString()
  } catch {
    return undefined
  }
}
